/**
 * @module helper.number
 */

/**
 * get length of precisions
 *
 * ```ts
 * getPrecisionLength(1.123) === 3
 * ```
 */
export function getPrecisionLength(arg: number): number {
	if (typeof arg !== 'number' || isNaN(arg)) {
		throw new Error('arg should be number');
	}

	const precisions = `${arg}`.split('.')[1];

	if (precisions === undefined) {
		return 0;
	}

	return precisions.length;
}
